import { render } from "./Car.vue?vue&type=template&id=0797b08f"
import script from "./Car.vue?vue&type=script&lang=js"
export * from "./Car.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Car.vue?vue&type=style&index=0&id=0797b08f&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script